<template>

  <div class="px-2">
    <!-- Header -->
    <div class="d-flex justify-content-between">

      <div class="mb-3">
        <div class="d-flex" style="position: absolute; ">

          <div class="d-flex" v-if="psIsAdmin && psShowDetail">
            <Button
              :size="20"
              color="#d42c2c"
              colorText="#ffffff"
              tooltip="Volver a resumen"
              text="Volver a resumen"
              :icon="'fas fa-angle-left'"
              :width="135"
              round
              :height="32"
              class="mr-2"
              :horizontal="true"
              :inactive="!psEnabledButtons"
              @click.native="psEnabledButtons ? actionSetPSShowDetail(false) : ''"
              traslate
            />
          </div>

          <filtro-planificacion-semanal />

          <Button
            :size="15"
            color="#28a745"
            colorText="#ffffff"
            tooltip="Agregar planificación semanal"
            icon="fas fa-plus"
            round
            :width="30"
            class="mr-2"
            traslate
            :inactive="psMultipleEditMode || !psEnabledButtons"
            @click.native="!psMultipleEditMode && psEnabledButtons ? actionSetPSCreateMode(true) : ''"
          />

          <div class="d-flex" v-if="!psIsAdmin && showDefault ||  psIsAdmin && psShowDetail">
            <Button
              :size="15"
              color="#ffc107"
              colorText="#ffffff"
              tooltip="Modificar múltiples planificaciones semanales"
              icon="far fa-edit"
              round
              :width="30"
              class="mr-2"
              :inactive="!psMultipleEditMode || !psEnabledButtons"
              @click.native="psMultipleEditMode && psEnabledButtons ? actionSetPSShowManageModal(true) : ''"
              traslate
            />

            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Cancelación de múltiples planificaciones semanales"
              icon="fas fa-times"
              round
              :width="30"
              class="mr-2"
              :inactive="!psMultipleEditMode || !psEnabledButtons"
              @click.native="psMultipleEditMode && psEnabledButtons ? cancelWeeklyPlans() : ''"
              traslate
            />
          </div>

          <Button
            :size="15"
            color="#28a745"
            colorText="#ffffff"
            tooltip="Exportar a Excel"
            icon="icon fas fa-file-excel"
            round
            :width="30"
            class="mr-2"
            :inactive="!psEnabledButtons"
            @click.native="psEnabledButtons ?  actionSetPSShowReportModal(true) : ''"
            traslate
          />
        </div>
      </div>
      <div v-if="psIsAdmin" class="" id="switch_envio_correo_ps" style="float: right">
        <ui-switch
          v-model="enabledNotifications" switch-position="right" @change="enablePSNotifications">
          Enviar recordatorio por correo
        </ui-switch>
      </div>
    </div>

    <!-- Body -->
    <div class="mt-3">

      <div v-show="psIsAdmin && !psShowDetail">
        <data-table-resumen-planificacion-semanal
          :data="dataResume"
          :current-weeks="psCurrentWeeks"
          :acciones="acciones"
          :idtabla="'planificacion_semanal_resumen'"
          :paginacion="true"
          :max="15"
        />
      </div>

      <div v-show="!psIsAdmin && showDefault ||  psIsAdmin && psShowDetail">
        <!--Tabla de planes semanales -->
        <data-table-planificacion-semanal
          :data="data"
          :current-weeks="psCurrentWeeks"
          :weeks-totals="psWeekTotals"
          :idtabla="'planificacion_semanal'"
          :paginacion="true"
          :max="15"/>
      </div>

      <!--Modal de gestion de planes semanales -->
      <gestionar-planificacion-semanal-modal />

      <!--Modal de gestion de planes semanales -->
      <reporte-planificacion-semanal-modal />

    </div>
  </div>

</template>

<script>

// Componentes
import Button from "../../common/Button";
import DataTablePlanificacionSemanal from "../../dataTables/lineas/DataTablePlanificacionSemanal";
import DataTableResumenPlanificacionSemanal from "../../dataTables/lineas/DataTableResumenPlanificacionSemanal.vue";
import FiltroPlanificacionSemanal from "../../filtros/lineas/FiltroPlanificacionSemanal";
import { mapActions, mapState } from "vuex";
import ReportePlanificacionSemanalModal
  from "@/components/modals/lineas/planificacionSemanal/ReportePlanificacionSemanalModal.vue";
import GestionarPlanificacionSemanalModal
  from "@/components/modals/lineas/planificacionSemanal/GestionarPlanificacionSemanalModal.vue";
import { cancelarPlanificacionSemanal, enablePSNotifications } from "@/constants/lineas";

export default {
  components: {
    FiltroPlanificacionSemanal,
    GestionarPlanificacionSemanalModal,
    Button,
    DataTablePlanificacionSemanal,
    DataTableResumenPlanificacionSemanal,
    ReportePlanificacionSemanalModal
  },
  data() {
    return {
      showDefault: false,
      acciones: [],
      dataResume: [],
      data: [],
      enabledNotifications: false,
      totals: {
        week1: [0, 0, 0],
        week2: [0, 0, 0],
        week3: [0, 0, 0],
        week4: [0, 0, 0],
        week5: [0, 0, 0]
      }
    };
  },
  computed: {
    ...mapState("lineas", [
      "psDataTable",
      "psResumeDataTable",
      "psDataTableFiltrada",
      "psResumeDataTableFiltrada",
      "psCurrentWeeks",
      "psDataSelected",
      "psDataSelectedToDelete",
      "psMultipleEditMode",
      "psEnabledButtons",
      "psWeekTotals",
      "dataPlanificacionSemanalTabla",
      "psEnabledNotifications",
      "psShowDetail",
      "psDetailPort",
      "psIsAdmin"
    ])
  },
  methods: {
    ...mapActions(["AccionCambiar", "ActionSetZindexTablaModal", "ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetPSShowManageModal",
      "actionSetPSShowReportModal",
      "actionSetPSCreateMode",
      "actionSetPSMultipleEditMode",
      "actionSetPSDataSelected",
      "actionSetPSDataSelectedToDelete",
      "actionSetPSCreateMode",
      "actionSetPSDataTable",
      "actionSetPSResumeDataTable",
      "actionSetPSEnabledButtons",
      "actionSetPSWeekTotals",
      "actionSetPSFiltroClientes",
      "actionSetPSFiltroPuertos",
      "actionSetPSFiltroContendores",
      "actionSetPSFiltroProductos",
      "actionSetPSCurrentWeeks",
      "actionSetPSListaClientes",
      "actionSetPSListaPuertos",
      "actionSetPSListaContendores",
      "actionSetPSFiltroClientes",
      "actionSetPSFiltroPuertos",
      "actionSetPSFiltroContendores",
      "actionSetPSFiltroProductos",
      "actionSetPSFiltroAnios",
      "actionSetPSFiltroSemanas",
      "actionSetDataPlanificacionSemanalTabla",
      "actionSetPSEnabledNotifications",
      "actionSetPSShowDetail",
      "actionSetPSIsAdmin"
    ]),
    async generarBotonesAcciones() {

      let me = this;

      me.acciones = [];

      me.dataResume.map((item, index) => {
        me.acciones.push([
          {
            icon: "fas fa-eye text-primary",
            title: "Ver Planificaciones",
            id: index
          }
        ]);
      });
    },
    //cancelar planes seleccionados
    cancelWeeklyPlans() {
      if (this.psMultipleEditMode) {
        this.$vToastify.prompt({
          body: "¿Está seguro(a) de que desea cancelar estas planificaciones semanales?",
          answers: {
            "Sí": true,
            "No": false
          }
        }).then(async value => {
          if (value) {

            this.$vToastify.loader("Cancelando planificaciones semanales...");
            this.actionSetPSEnabledButtons(false);

            let response = await cancelarPlanificacionSemanal(this.psDataSelectedToDelete);

            if (response.code === 200) {
              this.$vToastify.success(response.message, "Realizado con éxito");
              await this.clearSelectedPlans();
            } else {
              this.$vToastify.error(response.message, "Se produjo un error");
            }
            await this.actionSetDataPlanificacionSemanalTabla();
            this.$vToastify.stopLoader();
            this.actionSetPSEnabledButtons(true);
          }
        });
      }
    },
    //quitar checks y limpiar data posterior a ser procesada
    async clearSelectedPlans() {
      await this.removeCheckedToPlans();
      this.actionSetPSDataSelected([]);
    },
    //quita los checks de los planes seleccionados
    async removeCheckedToPlans() {
      this.psDataSelectedToDelete.forEach(item => {
        document.getElementById("chkbx" + item.temp_id).checked = false;
      });
    },
    //calcula el total semanal del datatable
    async totalsCalculation() {

      const cleared_totals = {
        week1: [0, 0, 0],
        week2: [0, 0, 0],
        week3: [0, 0, 0],
        week4: [0, 0, 0],
        week5: [0, 0, 0]
      };

      this.totals = cleared_totals;

      this.actionSetPSWeekTotals(cleared_totals);

      await this.data.forEach(element => {

        this.totals.week1[0] += parseInt(element.data[4]);
        this.totals.week1[1] += parseInt(element.data[5]);

        this.totals.week2[0] += parseInt(element.data[7]);
        this.totals.week2[1] += parseInt(element.data[8]);

        this.totals.week3[0] += parseInt(element.data[10]);
        this.totals.week3[1] += parseInt(element.data[11]);

        this.totals.week4[0] += parseInt(element.data[13]);
        this.totals.week4[1] += parseInt(element.data[14]);

        this.totals.week5[0] += parseInt(element.data[16]);
        this.totals.week5[1] += parseInt(element.data[17]);

        if (this.psIsAdmin) {
          this.totals.week1[2] += parseInt(element.data[6]);
          this.totals.week2[2] += parseInt(element.data[9]);
          this.totals.week3[2] += parseInt(element.data[12]);
          this.totals.week4[2] += parseInt(element.data[15]);
          this.totals.week5[2] += parseInt(element.data[18]);
        }

      });

      this.actionSetPSWeekTotals(this.totals);
    },
    //obtener si es admin o no
    async getAdmin() {
      let user = await JSON.parse(localStorage.getItem("user"));
      switch (user.rol) {
        case "Administrador":
        case "Super Administrador":
        case "Ejecutivo":
        case "Operador":
          this.actionSetPSIsAdmin(true);
      }
    },
    async enablePSNotifications() {
      let sql = await enablePSNotifications({
        "enabled": this.enabledNotifications
      });
      const status = Boolean(sql.enabled_notifications);
      this.actionSetPSEnabledNotifications(status);
    }
  },
  watch: {
    dataPlanificacionSemanalTabla: async function(_new) {
      if (_new.code === 200) {
        if (_new.type === 1) {
          this.actionSetPSResumeDataTable(_new.data);
          if (this.psShowDetail) {
            const results = _new.data.find(x => x.data[0] === this.psDetailPort);
            this.actionSetPSDataTable(results !== undefined && results.data_complementaria.length >= 1 ? results.data_complementaria : []);
          }
        } else {
          this.actionSetPSDataTable(_new.data);
        }

        this.actionSetPSCurrentWeeks(_new.current_weeks);

        this.actionSetPSEnabledNotifications(Boolean(_new.notifications_status));

        this.actionSetPSListaClientes(_new.customers_list);
        this.actionSetPSListaPuertos(_new.ports_list);
        this.actionSetPSListaContendores(_new.containers_list);

        this.actionSetPSFiltroClientes(_new.customers_filter);
        this.actionSetPSFiltroSemanas(_new.weeks_filter);
        this.actionSetPSFiltroPuertos(_new.ports_filter);
        this.actionSetPSFiltroContendores(_new.containers_filter);
        this.actionSetPSFiltroProductos(_new.products_filter);
        this.actionSetPSFiltroAnios(_new.years_filter);
      }
    },
    psDataSelected: function(data) {
      this.actionSetPSMultipleEditMode(data.length >= 1);
      if (data.length <= 0) {
        this.actionSetPSDataSelectedToDelete([]);
      }
    },
    psEnabledNotifications: function(_value) {
      this.enabledNotifications = Boolean(_value);
    },
    psResumeDataTable: async function(_new) {
      if (_new) {
        this.dataResume = _new;
        await this.generarBotonesAcciones();
      }
    },
    psResumeDataTableFiltrada: async function(_new) {
      this.dataResume = _new;
      await this.generarBotonesAcciones();
    },
    psDataTable: function(_new) {
      if (_new) {
        this.data = _new;
        this.totalsCalculation();
      }
    },
    psDataTableFiltrada: function(_new) {
      this.data = _new;
      this.totalsCalculation();
    }
  },
  mounted: async function() {
    await this.actionSetDataPlanificacionSemanalTabla();
  },
  beforeMount: async function() {
    await this.getAdmin();
    if (!this.psIsAdmin) {
      this.showDefault = true;
    }
  }
};
</script>